export const REVENUE_THRESHOLD = 2400000;
